import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Recursos from "../../components/carrusel/UserRecursosSociales";
import ServiciosAyuntamiento from "../../components/dashboard_tecnico/ServiciosAyuntamiento";
import "./css/Social.css";

const Social = () => {
  const { role } = useSelector((state) => state.auth);
  const [categoria, setCategoria] = useState("destacadas");

  return (
    <>
      <Navbar />

      <main className="main social empleo-formacion tecnicos">
        {/* Botón crear recurso - solo para administradores y tecnico-1 */}
        {(role === "administrador" || role === "tecnico-1") && (
          <div className="flex gap-10">
            <Link to="/admin/nuevo-recurso-social" className="boton azul social align-center mb-50 w-content">
              Dar de alta un recurso social
            </Link>
            <Link to="/admin/nuevo-servicio-social" className="boton azul social align-center mb-50 w-content">
              Dar de alta una entidad colaboradora
            </Link>
            <Link to="/admin/listado-programas" className="boton azul social align-center mb-50 w-content">
              Ver listado de programas
            </Link>
          </div>
        )}

        <section className="informacion-social column">
          <h1 className="titulo-user mayusculas align-center">
            recursos sociales:
            <select
              aria-label="Filtrados por"
              className="desplegable-empleo mayusculas ml-5"
              value={categoria}
              onChange={(e) => setCategoria(e.target.value)}
            >
              <option value="destacadas">destacados</option>
              <option value="Subvenciones">Subvenciones Temporales</option>
              <option value="Prestaciones">Prestaciones</option>
              <option value="Vivienda">Vivienda</option>
              <option value="todas">TODoS</option>
            </select>
          </h1>

          <Recursos categoria={categoria} />
        </section>

        <section className="informacion-social column">
          <h1 className="titulo-user mayusculas align-center">Entidades colaboradoras</h1>

          <ServiciosAyuntamiento />
        </section>
      </main>
    </>
  );
};

export default Social;
